export type PaymentMode = 'CHECK' | 'E_CHECK' | 'ACH' | 'WIRE' | 'CASH';

export interface ApplyPaymentRequest {
  invoiceNumbers: string[];
  paymentMode: PaymentMode;
  paymentDate?: Date | null;
  paymentAmount: number;
  totalInvoiceAmount: number;
  balance: number;
  memo?: string;
  checkNumber?: string;
  lastInvoiceNumber?: string;
}

export interface PaymentInvoice {
  paymentInvoiceId: string;
  invoiceNumber: string;
  appliedAmount: number;
  balance: number;
  adjustAmount: number;
  isLastInvoice: boolean;
  memo: string | null;
}

export interface ApplyPaymentResponse {
  invoices: PaymentInvoice[];
  createdBy: string;
  createdAt: string;
}

export interface PaymentModeOption {
  label: string;
  value: PaymentMode;
}

export const PAYMENT_MODE_OPTIONS: PaymentModeOption[] = [
  { label: 'Check', value: 'CHECK' },
  { label: 'E-check', value: 'E_CHECK' },
  { label: 'ACH', value: 'ACH' },
  { label: 'Wire', value: 'WIRE' },
  { label: 'Cash', value: 'CASH' },
];
